/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationRewardListEventInvitationRewardData model module.
 * @module model/EventsControllerDtoEventInvitationRewardListEventInvitationRewardData
 * @version 1.0
 */
class EventsControllerDtoEventInvitationRewardListEventInvitationRewardData {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationRewardListEventInvitationRewardData</code>.
     * @alias module:model/EventsControllerDtoEventInvitationRewardListEventInvitationRewardData
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationRewardListEventInvitationRewardData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationRewardListEventInvitationRewardData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationRewardListEventInvitationRewardData} The populated <code>EventsControllerDtoEventInvitationRewardListEventInvitationRewardData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationRewardListEventInvitationRewardData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('buyerAccountNo')) {
                obj['buyerAccountNo'] = ApiClient.convertToType(data['buyerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('buyerEmail')) {
                obj['buyerEmail'] = ApiClient.convertToType(data['buyerEmail'], 'String');
            }
            if (data.hasOwnProperty('marketListingNo')) {
                obj['marketListingNo'] = ApiClient.convertToType(data['marketListingNo'], 'Number');
            }
            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('tokenType')) {
                obj['tokenType'] = ApiClient.convertToType(data['tokenType'], 'Number');
            }
            if (data.hasOwnProperty('marketPrice')) {
                obj['marketPrice'] = ApiClient.convertToType(data['marketPrice'], 'Number');
            }
            if (data.hasOwnProperty('exchangeRate')) {
                obj['exchangeRate'] = ApiClient.convertToType(data['exchangeRate'], 'Number');
            }
            if (data.hasOwnProperty('reward')) {
                obj['reward'] = ApiClient.convertToType(data['reward'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationRewardListEventInvitationRewardData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationRewardListEventInvitationRewardData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['buyerEmail'] && !(typeof data['buyerEmail'] === 'string' || data['buyerEmail'] instanceof String)) {
            throw new Error("Expected the field `buyerEmail` to be a primitive type in the JSON string but got " + data['buyerEmail']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['email'] = undefined;

/**
 * @member {Number} buyerAccountNo
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['buyerAccountNo'] = undefined;

/**
 * @member {String} buyerEmail
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['buyerEmail'] = undefined;

/**
 * @member {Number} marketListingNo
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['marketListingNo'] = undefined;

/**
 * @member {Number} postNo
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['postNo'] = undefined;

/**
 * @member {Number} tokenType
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['tokenType'] = undefined;

/**
 * @member {Number} marketPrice
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['marketPrice'] = undefined;

/**
 * @member {Number} exchangeRate
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['exchangeRate'] = undefined;

/**
 * @member {Number} reward
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['reward'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationRewardListEventInvitationRewardData.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventInvitationRewardListEventInvitationRewardData;

